import { Injectable, Inject } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { APIBase } from './api.base';
import { Router } from '@angular/router';
import { SessionStorageService } from '../services/session-storage.service';

@Injectable()
export class CommissionsAPI extends APIBase {

	constructor(@Inject(AuthHttp) authHttp: AuthHttp, @Inject(Router) router: Router, @Inject(SessionStorageService) session: SessionStorageService) {
		super(authHttp, router, session);

		// Entidade principal
		this.__entity = 'commissions';
	}

	/**
	 * register_payment
	 *
	 * Registra que o comissionamento de um processo foi realizado
	 *
	 * @access public
	 * @author Murilo Spinoza de Arruda
	 * @since  01/2019
	 * @return object Promise
	 */
	public register_payment(processoId) {
		return this._call(this.__entity + '/register_payment/', { ProcessoId: processoId }, 'post');
	}
}


// WEBPACK FOOTER //
// ./src/api/commissions.api.ts